import {
  ADMIN_GET_ALL_ORDER_ACTIVITY,
  ADMIN_GET_ALL_PENDING_ACTIVITY,
  ADMIN_GET_ALL_ORDERING_DASHBOARD,
} from "../../types";

const initialState = {
  admin_get_all_order_activity: "",
  admin_get_all_pending_activity: "",
  admin_get_all_ordering_dashboard: "",
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ADMIN_GET_ALL_ORDER_ACTIVITY:
      return {
        ...state,
        admin_get_all_order_activity: payload,
      };
    case ADMIN_GET_ALL_PENDING_ACTIVITY:
      return {
        ...state,
        admin_get_all_pending_activity: payload,
      };
    case ADMIN_GET_ALL_ORDERING_DASHBOARD:
      return {
        ...state,
        admin_get_all_ordering_dashboard: payload,
      };
    default:
      return state;
  }
}
